import type { ReactNode } from 'react';

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  children?: ReactNode;
}

export default function PageHeader({ eyebrow, title, desc, children }: Props) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 md:px-6 pt-28 pb-10 md:pt-36 md:pb-14">
        {eyebrow && (
          <span className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <i className="ri-archive-line"></i>
            {eyebrow}
          </span>
        )}
        <h1 className="max-w-3xl font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
          {title}
        </h1>
        {desc && <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
        {children}
      </div>
    </section>
  );
}